import { useState, useEffect } from 'react';
import { adminAPI } from '@/services/api';

const PrintableStudentProfile = ({ student, payments, results }) => {
  return (
<div id="printable-student-profile" style={{ display: 'none' }}>
      <div style={{
        fontFamily: 'Arial, sans-serif',
        maxWidth: '800px',
        margin: '0 auto',
        padding: '40px 20px',
        color: '#000',
        lineHeight: '1.5'
      }}>
        
        {/* HEADER */}
        <div style={{ 
          textAlign: 'center', 
          borderBottom: '3px solid #1a5c38', 
          paddingBottom: '20px', 
          marginBottom: '30px' 
        }}>
          <h1 style={{ 
            color: '#1a5c38', 
            fontSize: '24px', 
            margin: '0 0 8px 0',
            fontWeight: 'bold'
          }}>
            Dar-ul-Hikmah College of Islamic and Arabic Studies
          </h1>
          <p style={{ 
            fontSize: '18px', 
            color: '#555', 
            margin: '4px 0 12px 0',
            fontWeight: '500'
          }}>
            بسم الله الرحمن الرحيم
          </p>
          <h2 style={{ 
            fontSize: '20px', 
            margin: '0 0 12px 0',
            color: '#1a5c38'
          }}>
            STUDENT PROFILE
          </h2>
          <p style={{ 
            fontSize: '14px', 
            color: '#666',
            margin: 0
          }}>
            Generated on {new Date().toLocaleDateString('en-GB', { 
              weekday: 'long', 
              day: 'numeric', 
              month: 'long', 
              year: 'numeric',
              hour: '2-digit',
              minute: '2-digit'
            })}
          </p>
        </div>

        {/* STUDENT BASIC INFO + PHOTO */}
        <div style={{ 
          display: 'flex', 
          gap: '24px', 
          marginBottom: '30px',
          alignItems: 'flex-start'
        }}>
          <div style={{ flex: 1 }}>
            <h3 style={{ 
              fontSize: '22px', 
              margin: '0 0 12px 0', 
              color: '#1a5c38',
              fontWeight: 'bold'
            }}>
              {student?.full_name || `${student?.first_name || ''} ${student?.last_name || ''}`.trim()}
            </h3>
            <div style={{ display: 'grid', gridTemplateColumns: 'auto 1fr', gap: '12px 24px' }}>
              <div style={{ fontWeight: 'bold', color: '#666', fontSize: '14px' }}>Admission No:</div>
              <div style={{ fontSize: '16px', fontWeight: '500' }}>{student?.admission_number || 'N/A'}</div>
              
              <div style={{ fontWeight: 'bold', color: '#666', fontSize: '14px' }}>Class:</div>
              <div style={{ fontSize: '16px', fontWeight: '500' }}>{student?.class || 'N/A'}</div>
              
              <div style={{ fontWeight: 'bold', color: '#666', fontSize: '14px' }}>Session:</div>
              <div style={{ fontSize: '16px', fontWeight: '500' }}>{student?.session || 'N/A'}</div>
              
              <div style={{ fontWeight: 'bold', color: '#666', fontSize: '14px' }}>Status:</div>
              <div style={{ 
                fontSize: '16px', 
                fontWeight: '500',
                color: student?.status === 'approved' ? '#28a745' : student?.status === 'rejected' ? '#dc3545' : '#ffc107',
                textTransform: 'uppercase'
              }}>
                {student?.status || 'N/A'}
              </div>
            </div>
          </div>
          <div style={{ flexShrink: 0 }}>
            {student?.picture ? (
              <img
                src={student.picture}
                alt="Student Photo"
                style={{ 
                  width: '120px', 
                  height: '140px', 
                  objectFit: 'cover', 
                  border: '3px solid #1a5c38',
                  borderRadius: '8px',
                  boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
                }}
              />
            ) : (
              <div style={{ 
                width: '120px', 
                height: '140px', 
                background: '#f8f9fa',
                border: '3px solid #dee2e6',
                borderRadius: '8px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: '#6c757d',
                fontSize: '48px'
              }}>
                📷
              </div>
            )}
          </div>
        </div>

        {/* PERSONAL DETAILS */}
        <div style={{ marginBottom: '30px' }}>
          <h3 style={{ 
            color: '#1a5c38', 
            fontSize: '18px', 
            margin: '0 0 16px 0',
            borderBottom: '2px solid #1a5c38',
            paddingBottom: '8px'
          }}>
            Personal Information
          </h3>
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '14px' }}>
            <tbody>
            <tr style={{ borderBottom: '1px solid #eee' }}>
              <td style={{ padding: '12px 16px 12px 0', fontWeight: '600', width: '35%', background: '#f8f9fa' }}>Full Name</td>
              <td style={{ padding: '12px 16px' }}>{student?.full_name || `${student?.first_name || ''} ${student?.last_name || ''}`.trim() || 'N/A'}</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #eee' }}>
              <td style={{ padding: '12px 16px 12px 0', fontWeight: '600', background: '#f8f9fa' }}>Email</td>
              <td style={{ padding: '12px 16px' }}>{student?.email || 'N/A'}</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #eee' }}>
              <td style={{ padding: '12px 16px 12px 0', fontWeight: '600', background: '#f8f9fa' }}>Phone</td>
              <td style={{ padding: '12px 16px' }}>{student?.phone || 'N/A'}</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #eee' }}>
              <td style={{ padding: '12px 16px 12px 0', fontWeight: '600', background: '#f8f9fa' }}>Date of Birth</td>
              <td style={{ padding: '12px 16px' }}>{student?.date_of_birth ? new Date(student.date_of_birth).toLocaleDateString('en-GB') : 'N/A'}</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #eee' }}>
              <td style={{ padding: '12px 16px 12px 0', fontWeight: '600', background: '#f8f9fa' }}>Gender</td>
              <td style={{ padding: '12px 16px' }}>{student?.gender || 'N/A'}</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #eee' }}>
              <td style={{ padding: '12px 16px 12px 0', fontWeight: '600', background: '#f8f9fa' }}>Religion</td>
              <td style={{ padding: '12px 16px' }}>{student?.religion || 'N/A'}</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #eee' }}>
              <td style={{ padding: '12px 16px 12px 0', fontWeight: '600', background: '#f8f9fa' }}>State of Origin</td>
              <td style={{ padding: '12px 16px' }}>{student?.state_of_origin || 'N/A'}</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #eee' }}>
              <td style={{ padding: '12px 16px 12px 0', fontWeight: '600', background: '#f8f9fa' }}>LGA</td>
              <td style={{ padding: '12px 16px' }}>{student?.lga || 'N/A'}</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #eee' }}>
              <td style={{ padding: '12px 16px 12px 0', fontWeight: '600', background: '#f8f9fa' }}>Home Address</td>
              <td style={{ padding: '12px 16px' }}>{student?.home_address || 'N/A'}</td>
            </tr>
            </tbody>
          </table>
        </div>

        {/* PARENT/GUARDIAN */}
        <div style={{ marginBottom: '30px' }}>
          <h3 style={{ 
            color: '#1a5c38', 
            fontSize: '18px', 
            margin: '0 0 16px 0',
            borderBottom: '2px solid #1a5c38',
            paddingBottom: '8px'
          }}>
            Parent / Guardian Information
          </h3>
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '14px' }}>
            <tbody>
            <tr style={{ borderBottom: '1px solid #eee' }}>
              <td style={{ padding: '12px 16px 12px 0', fontWeight: '600', width: '35%', background: '#f8f9fa' }}>Full Name</td>
              <td style={{ padding: '12px 16px' }}>{student?.parent_name || 'N/A'}</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #eee' }}>
              <td style={{ padding: '12px 16px 12px 0', fontWeight: '600', background: '#f8f9fa' }}>Phone</td>
              <td style={{ padding: '12px 16px' }}>{student?.parent_phone || 'N/A'}</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #eee' }}>
              <td style={{ padding: '12px 16px 12px 0', fontWeight: '600', background: '#f8f9fa' }}>Email</td>
              <td style={{ padding: '12px 16px' }}>{student?.parent_email || 'N/A'}</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #eee' }}>
              <td style={{ padding: '12px 16px 12px 0', fontWeight: '600', background: '#f8f9fa' }}>Relationship</td>
              <td style={{ padding: '12px 16px' }}>{student?.relationship || 'N/A'}</td>
            </tr>
            </tbody>
          </table>
        </div>

        {/* ACADEMIC */}
        <div style={{ marginBottom: '30px' }}>
          <h3 style={{ 
            color: '#1a5c38', 
            fontSize: '18px', 
            margin: '0 0 16px 0',
            borderBottom: '2px solid #1a5c38',
            paddingBottom: '8px'
          }}>
            Academic Information
          </h3>
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '14px' }}>
            <tbody>
            <tr style={{ borderBottom: '1px solid #eee' }}>
              <td style={{ padding: '12px 16px 12px 0', fontWeight: '600', width: '35%', background: '#f8f9fa' }}>Class</td>
              <td style={{ padding: '12px 16px' }}>{student?.class || 'N/A'}</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #eee' }}>
              <td style={{ padding: '12px 16px 12px 0', fontWeight: '600', background: '#f8f9fa' }}>Session</td>
              <td style={{ padding: '12px 16px' }}>{student?.session || 'N/A'}</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #eee' }}>
              <td style={{ padding: '12px 16px 12px 0', fontWeight: '600', background: '#f8f9fa' }}>Previous School</td>
              <td style={{ padding: '12px 16px' }}>{student?.previous_school || 'N/A'}</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #eee' }}>
              <td style={{ padding: '12px 16px 12px 0', fontWeight: '600', background: '#f8f9fa' }}>Date Joined</td>
              <td style={{ padding: '12px 16px' }}>{student?.created_at ? new Date(student.created_at).toLocaleDateString('en-GB') : 'N/A'}</td>
            </tr>
            </tbody>
          </table>
        </div>

        {/* FOOTER */}
        <div style={{ 
          borderTop: '3px solid #1a5c38', 
          paddingTop: '20px', 
          textAlign: 'center',
          fontSize: '13px', 
          color: '#666',
          marginTop: '40px'
        }}>
          <p style={{ margin: '0 0 4px 0', fontWeight: '500' }}>
            Generated by Dar-ul-Hikmah College Management System
          </p>
          <p style={{ margin: 0, fontSize: '12px' }}>
            This document is computer generated and valid without signature
          </p>
        </div>

      </div>
    </div>
  );
};

export default PrintableStudentProfile;

